import React from 'react';
import AssignedPerson from './AssignedPerson';
import TaskAction from './TaskAction';

const SingleTask = ({
  color,
  task,
  title,
  date,
  month,
  image,
  name,
  status,
  id,
}) => {
  return (
    <div className="lws-task">
      <div className="flex items-center gap-2 text-slate">
        <h2 className="lws-date">{date}</h2>
        <h4 className="lws-month">{month}</h4>
      </div>

      <div className="lws-taskContainer">
        <h1 className="lws-task-title">{title}</h1>
        <span className={`lws-task-badge ${color}`}>{task}</span>
      </div>

      <div className="flex items-center gap-4">
        <AssignedPerson name={name} image={image} />
        <TaskAction status={status} id={id} />
      </div>
    </div>
  );
};

export default SingleTask;
